export default "__VITE_ASSET__DakQeXQK__"